export default function (error) {
  return error?.name === 'ChunkLoadError' || error?.code === 'CSS_CHUNK_LOAD_FAILED'
}
